module.exports = __webpack_public_path__ + "static/media/selected-icon.7d577c27.svg";